// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// constants
const blacklisteTableFilterInitialValue = {
  page: 0,
  name: '',
  query: '',
  sortBy: 'domain',
  sortDir: 'asc',
  pageSize: 50
}
const tenantsTableFilterInitialValue = {
  pageSize: 50,
  page: 0,
  sortBy: 'name',
  sortDir: 'asc',
  query: ''
}

const attemptsTableFilterInitialValue = {
  tenantId: '',
  search: '',
  page: 0,
  size: 10,
  fromDate: '',
  toDate: '',
  sort: 'modifiedTimestamp',
  order: 'desc',
  attemptId: '',
  challengeTypeId: ''
}

export const developerSlice = createSlice({
  name: 'developer',
  initialState: {
    blacklistedDomainFilters: { ...blacklisteTableFilterInitialValue },
    tenantsFilters: { ...tenantsTableFilterInitialValue },
    attemptsFilters: { ...attemptsTableFilterInitialValue }
  },
  reducers: {
    setBlacklistedTableFilters(state, action) {
      state.blacklistedDomainFilters = action.payload
    },
    setTenantsTableFilters(state, action) {
      state.tenantsFilters = action.payload
    },
    setAttemptsPageFilters(state, action) {
      state.attemptsFilters = action.payload
    }
  }
})

export const {
  setBlacklistedTableFilters,
  setTenantsTableFilters,
  setAttemptsPageFilters
} = developerSlice.actions

export default developerSlice.reducer
